import { render, staticRenderFns } from "./BTextArea.vue?vue&type=template&id=2808f62f"
import script from "./BTextArea.vue?vue&type=script&lang=js"
export * from "./BTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports